module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g({
    class: _vm.inputClass
  }, _vm.listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9edd8ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/inputmask/InputMask.vue
// module id = 2444
// module chunks = 0